<!-- <div class="abv_flx">
  <span class="exchange">Exchange</span>
  <div class="drpdwn_box">
    <div class="dropdown">
      <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
        aria-expanded="false">
        <img src="assets/images/new-logo.svg" class="img-fluid" alt="icon"> CredBull
        <img src="assets/images/binance.svg" class="img-fluid" alt="icon"> Binance
      </button>
      <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <li><a class="dropdown-item" role="button" href="javascript:void(0)"><img src="assets/images/binance.svg"
              class="img-fluid" alt="icon"> Binance</a></li>
        <li><a class="dropdown-item" role="button" href="javascript:void(0)"><img src="assets/images/bybit.svg"
              class="img-fluid" alt="icon"> Bybit</a></li>
      </ul>
    </div>
  </div>
</div> -->
<div class="coin_details zindex">
  <div class="card trade_card">
    <div class="card-header">
      <h2>Recent Trades</h2>
    </div>
    <div class="trade_historyorder_wrapper">

      <div class="basetable_wrap">
        <div class="basetable_wrapper">
          <div class="basetable_thead_row">
            <div class="basetable_thead_th">Time</div>
            <div class="basetable_thead_th text-end">
              Price ({{tradePair?.secondCurrencySymbol}})
            </div>
            <div class="basetable_thead_th text-end">
              Amount ({{tradePair?.firstCurrencySymbol}})
            </div>
          </div>

          <div class="basetable_body">
            <div class="basetable_row" *ngFor="let data of recentTrade;">
              <div class="basetable_cell">{{data?.createdAt | date:"hh:mm:ss"}}</div>
              <div class="basetable_cell trade_history_tablecell_txtend">
                <span [class]="data.Type == 'sell' ? 'red_txt': 'green_txt'"
                  [title]="toFixed(data?.tradePrice, tradePair?.secondFloatDigit)">
                  {{fraction(toFixed(data?.tradePrice, tradePair?.secondFloatDigit), tradePair?.secondFloatDigit)}}
                </span>
              </div>
              <div class="basetable_cell trade_history_tablecell_txtend">
                <span class="" style="color: #797979;" [title]="toFixed(data?.tradeQty, tradePair?.firstFloatDigit)">
                  {{fraction(toFixed(data?.tradeQty, tradePair?.firstFloatDigit), tradePair?.firstFloatDigit)}}
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>